import React from 'react';
import { DirectionArrowSVG, getDirectionText } from '../../../utils/helpers';

const WindDirection10mRow = ({dayData, units, data}) => {

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block sm:hidden">Wind&nbsp;D</span>
                        <span className="hidden sm:inline-block">Wind Direction&nbsp;10m</span>
                    </div>
                </div>
            </td>
            {dayData.map(({ index }) => {
                const windDirection = data?.[index];
                return (
                    <td key={index} className="py-1 text-center">
                        {units ? (
                            <div className="inline-block min-w-[30px] text-center">
                                <div className="flex flex-col items-center gap-1">
                                    <DirectionArrowSVG degrees={windDirection} size={24} color="#fed900" />
                                    {/* <span className="text-xs text-custom-light-grey font-medium">
                                        {getDirectionText(windDirection)}
                                    </span> */}
                                </div>
                            </div>
                        ) : null}
                    </td>
                );
            })}
        </tr>
    )
}

export default WindDirection10mRow;